import React, { useState } from 'react';
import {useNotificationMessage} from "../../hooks/NotificationContext";
import {getEffectName} from "../../utils/ImageEffect";
import {EffectCards} from "../../constants";

interface IFeaturesProps {
    isLight: boolean;
    setCurSelectedEffect: (effect: string) => void;
}

export const Features: React.FC<IFeaturesProps> = ({isLight, setCurSelectedEffect}) => {
    const {showNotification} = useNotificationMessage();
    const [selectedEffect, setSelectedEffect] = useState('');

    // 处理特效卡片点击
    const handleEffectClick = (effectId: string) => {
        setSelectedEffect(effectId);
        setCurSelectedEffect(effectId);
        showNotification(`Selected: ${getEffectName(effectId)}`, 'success');
    };

    return (
        <section id="features" className={`i-ability mt-[5%] py-16 px-4 ${isLight ? 'bg-white' : ''}`}>
            <div className="container mx-auto">
                <h2 className={`text-3xl font-bold text-center mb-12 ${isLight ? 'text-gray-800' : 'text-gray-500'}`}>
                    Innovation<span className="text-indigo-600">&nbsp;Function</span></h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                    {EffectCards.map(card => (
                        <div
                            key={card.id}
                            className={`
                                effect-card p-6 ${isLight ? 'bg-gray-50' : 'bg-gray-500'} rounded-xl 
                                ${selectedEffect === card.id ? (isLight ? 'bg-indigo-100 border-indigo-300' : 'bg-indigo-300 border-indigo-500') : ''}`}
                            onClick={() => handleEffectClick(card.id)}
                        >
                            <div
                                className={`w-16 h-16 ${isLight ? 'bg-indigo-200' : 'bg-indigo-100'} rounded-full flex items-center justify-center mb-4 mx-auto`}>
                                <i className={`fas ${card.icon} text-indigo-600 text-2xl`}></i>
                            </div>
                            <h3 className={`text-xl ${isLight ? 'text-black' : 'text-white'} font-semibold text-center mb-2`}>{card.title}</h3>
                            <p className={`${isLight ? 'text-gray-600' : 'text-gray-300'} text-center`}>{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
